import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatetimePickerComponent } from './datetime-picker/datetime-picker.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '@abp/ng.core';
import { LdmCoreModule } from 'src/app/core/core.module';
@NgModule({
  declarations: [DatetimePickerComponent],
  imports: [CommonModule, NgbModule, FormsModule, LdmCoreModule, CoreModule],

  exports: [DatetimePickerComponent],
})
export class DatetimePickerModule {}
